import handleMethod from '../Utils/APIutils/handleMethod';

class IngestionAPI {
  async listRuns({ page = 1, itemsPerPage = 20 } = {}) {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('itemsPerPage', itemsPerPage);
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/ingestion/runs?${params.toString()}`,
    });
  }

  async listDeviceResults(runId, { page = 1, itemsPerPage = 50 } = {}) {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('itemsPerPage', itemsPerPage);
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/ingestion/runs/${runId}/device-results?${params.toString()}`,
    });
  }

  async trigger() {
    return handleMethod({
      type: 'POST',
      method: 'api/gatewaycontagem/ingestion/trigger',
      params: {},
    });
  }

  async getStatus() {
    return handleMethod({
      type: 'GET',
      method: 'api/gatewaycontagem/ingestion/status',
    });
  }

  async retryRun(runId) {
    return handleMethod({
      type: 'POST',
      method: `api/gatewaycontagem/ingestion/runs/${runId}/retry`,
      params: {},
    });
  }
}

export const ingestionAPI = new IngestionAPI();
